/**
 * LIORA — voile flou derriere le tiroir panier, sur ordinateur.
 *
 * Le tiroir du theme a deux modes. Sous 990 px il s'ouvre en `showModal()` :
 * la page est inerte et le navigateur pose deja un voile natif, auquel il suffit
 * d'ajouter du flou en CSS. Au-dessus de 990 px il s'ouvre en `show()`, non
 * modal : la boutique est repoussee sur le cote et reste cliquable, mais aucun
 * voile n'existe. C'est ce cas que ce module couvre.
 *
 * Le voile est `pointer-events: none`. Ce n'est pas un detail : un calque qui
 * intercepte les clics obligerait a cliquer deux fois, une fois pour le chasser
 * et une fois pour atteindre le lien vise. Ici le clic traverse, le voile
 * disparait et l'action demandee part dans le meme geste.
 *
 * Le voile ne revient pas tant que le tiroir reste ouvert : le visiteur a
 * signale qu'il voulait continuer a naviguer, le lui remettre serait le contredire.
 * Fermer le tiroir remet le compteur a zero.
 */
const DESKTOP_QUERY = '(min-width: 990px)';
const DRAWER_ID = 'cart-drawer';

const desktop = window.matchMedia(DESKTOP_QUERY);

/** @type {HTMLElement | null} */
let veil = null;

/** Le visiteur a chasse le voile : on ne le remet pas avant la prochaine ouverture. */
let dismissed = false;

function drawer() {
  return document.getElementById(DRAWER_ID);
}

function isCartDrawer(event) {
  return event.target instanceof HTMLElement && event.target.id === DRAWER_ID;
}

function show() {
  if (!desktop.matches || dismissed || veil) return;

  veil = document.createElement('div');
  veil.className = 'liora-veil';
  veil.setAttribute('aria-hidden', 'true');
  document.body.appendChild(veil);

  // Deux images d'ecart : sans cela l'element est peint directement opaque et
  // la transition d'apparition ne se declenche pas.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => veil?.classList.add('liora-veil--in'));
  });

  // `capture` : on veut savoir que le clic a eu lieu avant que la cible ne
  // l'exploite, meme si elle arrete la propagation.
  document.addEventListener('pointerdown', onPointerDown, true);
}

function hide() {
  document.removeEventListener('pointerdown', onPointerDown, true);

  const node = veil;
  veil = null;
  if (!node) return;

  node.classList.remove('liora-veil--in');
  node.addEventListener('transitionend', () => node.remove(), { once: true });

  // Filet : sans transition (mouvement reduit, onglet en arriere-plan),
  // `transitionend` ne part jamais et le noeud resterait dans le DOM.
  setTimeout(() => node.remove(), 700);
}

function onPointerDown(event) {
  const panel = drawer();
  if (panel && event.target instanceof Node && panel.contains(event.target)) return;

  dismissed = true;
  hide();
}

document.addEventListener('theme-drawer:open', (event) => {
  if (!isCartDrawer(event)) return;
  dismissed = false;
  show();
});

document.addEventListener('theme-drawer:close', (event) => {
  if (!isCartDrawer(event)) return;
  dismissed = false;
  hide();
});

// Passage sous 990 px : le tiroir bascule en modal et le voile natif prend le
// relais, le notre ferait double emploi. Au retour, on le remet si le visiteur
// ne l'avait pas chasse.
desktop.addEventListener('change', () => {
  if (!desktop.matches) {
    hide();
  } else if (drawer()?.hasAttribute('open')) {
    show();
  }
});